namespace Areas.ReAssigned {
    "use strict";

    var selectedIDs;

    function OnBeginCallback(s, e) {
        e.customArgs["selectedInspectionIds"] = selectedIDs;
    }

    function OnSelectionChanged(s, e) {
        s.GetSelectedFieldValues("InspectionId", GetSelectedInspections);
    }

    function GetSelectedInspections(values) {
        selectedIDs = values.join(',');
        $("#selectedInspectionIds").val(selectedIDs);
    }

}
